import React from 'react';
import queryString from 'query-string';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Browser from '../util/Browser';

const creativeStyle = {
  height: '100%',
  display: 'grid',
  margin: '0 auto',
  width: '100% !important',
  maxWidth: '100%',
  objectPosition: '0 0',
  objectFit: 'contain',
};

class Creative extends React.Component {
  constructor(props) {
    super(props);
    this.selector = React.createRef();
  }

  componentDidMount() {
    console.log('>>>>> Creative.componentDidMount()');
    let {
      ad: { click_action, click_through_url },
      iframeSrc,
      creative: { noPixel, scriptHost, pixel },
    } = this.props;

    // Only for previews
    if (Browser.getParameterValue('preview_in_browser')) {
      this.applyStyleFixes();
    }

    if (!noPixel) {
      let thirdPartyPels = Browser.thirdPartyPels();
      window.imScriptHost = Browser.scriptHost();

      const params = queryString.parseUrl(iframeSrc);
      this.setState({ ad_id: get(params, 'query.ad_id') });
      let thirdParams = params.query;
      if (thirdParams.url) {
        thirdParams = {
          ...thirdParams,
          ...queryString.parseUrl(thirdParams.url).query,
        };
      }

      // add params needed for 3pt_pels script to process deeplinks
      thirdParams.click_action = click_action;
      thirdParams.click_through_url = click_through_url;

      // An empty line is required for the script to pick it up
      if (!thirdParams.m2m_impr_hash) {
        thirdParams.m2m_impr_hash = '';
      }
      thirdParams = queryString.stringify(thirdParams);

      const script = document.createElement('script');
      script.src = `//${thirdPartyPels}&${thirdParams}`;
      script.async = true;
      script.setAttribute('m2m', true);
      console.log('Creative.componentDidMount() addingtopage - script');
      console.log(script.src);
      document.body.appendChild(script);
    }

    const debug = document.getElementById('moatParamsTextArea');
    if (debug) {
      document.getElementById('moatParamsTextArea').style.background = 'red';
      document.getElementById('moatParamsTextArea').style.color = 'white';
    }
  }

  componentDidUpdate = prevProps => {
    if (this.props.firedPixels && !prevProps.firedPixels) {
      this.reportViewSize();
    }
  };

  applyStyleFixes = () => {
    const logPrefix = 'DOM Takeover Fixer - ';
    console.log(`${logPrefix}applying styling fixes for launch UI e2 preview`);

    const noSrcStr = `body { overflow-y: hidden; }`;

    const style = document.createElement('style');
    style.id = 'style-fixes-e2-launch';
    style.appendChild(document.createTextNode(noSrcStr));

    // Remove any styles we may have already added
    try {
      const element = window.parent.document.getElementById('style-fixes-e2-launch');
      element.parentNode.removeChild(element);
    } catch (e) {
      // Nothing to worry about, style wasn't added yet
    }

    try {
      window.parent.document.getElementsByTagName('head')[0].appendChild(style);
    } catch (e) {
      document.getElementsByTagName('head')[0].appendChild(style);
    }
  };

  isInViewport = bounding => {
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth;
    const top = bounding.top >= 0;
    const left = bounding.left >= 0;
    const bottom = bounding.bottom <= windowHeight;
    const right = bounding.right <= windowWidth;

    const debugs = [];
    if (!top) debugs.push(`bounding.top: ${bounding.top} not >= 0`);
    if (!left) debugs.push(`bounding.left: ${bounding.left} not >= 0`);
    if (!bottom) debugs.push(`bounding.bottom: ${bounding.bottom} not <= ${windowHeight}`);
    if (!right) debugs.push(`bounding.right: ${bounding.right} not <= ${windowWidth}`);

    const enable = debugs && debugs.length;
    if (true || enable) {
      console.log('debug-viewability', debugs);

      const sendToServer = debugs.join('\n');
      const {
        ad: { impression_id },
        componentName,
      } = this.props;
      const { ad_id } = this.state;
      const viewableDebug = {
        screenDetails: Browser.getScreenDetails(),
        pixelRatio: get(window, 'devicePixelRatio'),
        orientation: Math.abs(get(window, 'orientation', 0)) - 90 == 0 ? 'landscape' : 'portrait',
        availSize: `${get(window, 'screen.availHeight')} x ${get(window, 'screen.availWidth')}`,
        size: `${get(window, 'screen.height')} x ${get(window, 'screen.width')}`,
        innerSize: `${get(window, 'innerHeight')} x ${get(window, 'innerWidth')}`,
        ad_id,
        msg: sendToServer,
      };

      console.log('Viewable debug', viewableDebug);
      window.server.log({
        src: 'Creative.js',
        fn: 'Creative.isInViewport',
        tag: 'NOT_FULLY_VIEWABLE',
        inmarketParams: {
          componentName,
          m2m_impr_id: impression_id,
        },
        meta_data: viewableDebug,
      });
    }

    return top && left && bottom && right;
  };

  reportViewSize = () => {
    if (this.props.firedPixels) {
      const rect = this.selector.current.getBoundingClientRect();
      this.isInViewport(rect);
    }
  };

  render() {
    const {
      style,
      logTagLoadError,
      creative: { creative_url, secondary_pixel_url, click_through_url },
    } = this.props;

    const params = queryString.parseUrl(secondary_pixel_url || '');
    const hasClick = !isEmpty(get(params, 'query.final_dest_url')) || !isEmpty(click_through_url);

    return (
      <div style={style} ref={this.selector}>
        <a
          id="creative-link"
          target="_blank"
          rel="noopener noreferrer"
          href={secondary_pixel_url || click_through_url}
          onClick={e => {
            if (!hasClick) e.preventDefault();
          }}
        >
          <img
            id="creative-image"
            alt="Creative"
            style={creativeStyle}
            src={creative_url}
            border="0"
            onError={evt => {
              logTagLoadError('CardView.render', 'CREATIVE_LOAD_ONERROR', evt);
            }}
            onLoad={() => {
              console.log('didFinishLoad Creative image has loaded');
              this.reportViewSize();
              this.props.didFinishLoad();
            }}
          />
        </a>
      </div>
    );
  }
}

export default Creative;
